import VerifyIdComponent from './VerifyId.vue'

const VerifyId = {
  install:function(Vue){
    Vue.component('VerifyId',VerifyIdComponent)
  }
};

export default VerifyId



// WEBPACK FOOTER //
// ./src/components/VerifyId/index.js